var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("v-autocomplete", {
        staticClass: "mb-4",
        attrs: {
          items: _setup.searchResults,
          loading: _setup.searching,
          "search-input": _setup.addTerm,
          "item-text": "name",
          "item-value": "id",
          label: "Adicionar usuário ao perfil",
          placeholder: "Digite o nome ou e-mail para buscar…",
          "prepend-inner-icon": "mdi-account-plus",
          "return-object": "",
          outlined: "",
          dense: "",
          clearable: "",
          "hide-no-data": "",
          "hide-details": "",
          "no-filter": "",
        },
        on: {
          "update:searchInput": function ($event) {
            _setup.addTerm = $event
          },
          "update:search-input": function ($event) {
            _setup.addTerm = $event
          },
          change: _setup.addUser,
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function ({ item }) {
              return [
                _c(
                  "v-list-item-avatar",
                  [
                    _c("EmcBaseAvatar", {
                      attrs: {
                        text: _setup.initials(item.name),
                        src: item.url_avatar,
                        size: 36,
                        color: "primary",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "v-list-item-content",
                  [
                    _c("v-list-item-title", [_vm._v(_vm._s(item.name))]),
                    _c("v-list-item-subtitle", [_vm._v(_vm._s(item.email))]),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
        model: {
          value: _setup.selectedUser,
          callback: function ($$v) {
            _setup.selectedUser = $$v
          },
          expression: "selectedUser",
        },
      }),
      _c(
        "div",
        { staticClass: "d-flex align-center mb-2" },
        [
          _c(
            "v-icon",
            {
              staticClass: "mr-2",
              attrs: { small: "", color: "grey darken-1" },
            },
            [_vm._v("mdi-account-group")]
          ),
          _c("span", { staticClass: "subtitle-2 grey--text text--darken-2" }, [
            _vm._v("Usuários vinculados"),
          ]),
          _c("v-spacer"),
          _c(
            "v-chip",
            {
              attrs: {
                "x-small": "",
                label: "",
                outlined: "",
                color: "primary",
              },
            },
            [_vm._v(_vm._s(_setup.total))]
          ),
        ],
        1
      ),
      _c("v-text-field", {
        staticClass: "mb-3",
        attrs: {
          "prepend-inner-icon": "mdi-magnify",
          label: "Filtrar vinculados",
          dense: "",
          outlined: "",
          clearable: "",
          "hide-details": "",
        },
        on: { input: _setup.onSearch },
        model: {
          value: _setup.search,
          callback: function ($$v) {
            _setup.search = $$v
          },
          expression: "search",
        },
      }),
      _c(
        "v-card",
        { attrs: { outlined: "" } },
        [
          _c("v-data-table", {
            attrs: {
              headers: _setup.headers,
              items: _setup.users,
              "server-items-length": _setup.total,
              options: _setup.options,
              loading: _setup.loading,
              "footer-props": { "items-per-page-options": [5, 10, 20, 50] },
              dense: "",
            },
            on: {
              "update:options": function ($event) {
                _setup.options = $event
              },
            },
            scopedSlots: _vm._u([
              {
                key: "item.name",
                fn: function ({ item }) {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex align-center py-1" },
                      [
                        _c("EmcBaseAvatar", {
                          staticClass: "mr-2",
                          attrs: {
                            text: _setup.initials(item.name),
                            src: item.url_avatar,
                            size: 32,
                            color: "primary",
                          },
                        }),
                        _vm._v(" " + _vm._s(item.name) + " "),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "item.actions",
                fn: function ({ item }) {
                  return [
                    _c(
                      "v-tooltip",
                      {
                        attrs: { bottom: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function ({ on, attrs }) {
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          attrs: {
                                            icon: "",
                                            small: "",
                                            color: "error",
                                            loading:
                                              _setup.removingId === item.id,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _setup.removeUser(item)
                                            },
                                          },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _c("v-icon", { attrs: { small: "" } }, [
                                        _vm._v("mdi-account-remove"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [_c("span", [_vm._v("Remover do perfil")])]
                    ),
                  ]
                },
              },
              {
                key: "no-data",
                fn: function () {
                  return [
                    _c("div", { staticClass: "grey--text py-4 caption" }, [
                      _vm._v("Nenhum usuário vinculado a este perfil."),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "v-alert",
        {
          staticClass: "mt-3 mb-0",
          attrs: { dense: "", text: "", type: "info", border: "left" },
        },
        [
          _vm._v(
            " As alterações de usuários são aplicadas imediatamente — não dependem do botão Salvar. "
          ),
        ]
      ),
      _c("emc-alert-snackbar", {
        attrs: {
          show: !!_setup.message.length,
          message: _setup.message,
          color: _setup.error ? "error" : "success",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }